import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-processing',
  templateUrl: './status-processing.component.html',
  styleUrls: ['./status-processing.component.scss'],
})
export class StatusProcessingComponent {
  @Input() titulo: string = '';
  @Input() subtitulo: string = '';
  @Input() mostrar: boolean = true;
}
